import React from 'react';
import { SpeciesCarousel } from '../components/TreeSpecies/SpeciesCarousel';

export const SpeciesPage: React.FC = () => {
  return (
    <div className="h-full w-full p-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Tree Species Catalog</h1>
          <p className="mt-2 text-gray-600">
            Explore native and adapted tree species suitable for urban forestry in the Hackensack area.
          </p>
        </div>
        
        <SpeciesCarousel />
      </div>
    </div>
  );
};
